import { gql } from '@apollo/client';
import { Gender, IBaseEntity, IDoctor } from '@dokucoach/common-types';
import { doctorBaseData } from 'services/query/doctors';

export interface DoctorNameAndId {
  id: string;
  name: {
    firstFull: string;
    last: string;
    title?: string;
  };
}

export type DoctorListData = {
  id: string;
  deletedAt?: Date | null;
  name: {
    firstFull: string;
    last: string;
    gender: Gender;
    title: string;
  };
};

export type DoctorPropType = IDoctor & IBaseEntity;

export const GET_DOCTOR_BY_ID = gql`
  query getDoctor($id: String!){
    getDoctor(id: $id){
      ${doctorBaseData}
    }
  }
`;

export const GET_ALL_DOCTORS = gql`
  query getAllDoctors($isDeleted: Boolean!){
    getAllDoctors(isDeleted: $isDeleted){
      ${doctorBaseData}
    }
  }
`;

export const GET_BASE_DATA_SUGGESTIONS = gql`
  query getBaseDataSuggestions {
    suggestion {
      baseDataSuggestions {
        doctorGeneralSubjectArea {
          values
        }
      }
    }
  }
`;
